import { SearchProps } from '~components/form-fields/search';

import { selectLookupAppointmentServiceTypes } from '~appointments/selectors/serviceTypes';
import { selectAppointmentStatuses } from '~appointments/selectors/statuses';
import { selectClientPackages } from '~main/selectors/clients/clientPackages';
import { selectClientReferrers } from '~main/selectors/clients/clientReferrers';

const fields: SearchProps = {
  reference_number: {
    type: 'text-like',
    field: 'reference_number',
    placeholder: 'Search reference',
    caption: 'Reference',
  },
  date: {
    defaultShow: true,
    type: 'date-range',
    field: 'date',
    caption: 'Date',
  },
  referrer: {
    type: 'multi-lookup',
    field: 'client.referrer_name',
    caption: 'Referrer',
    placeholder: 'All',
    selectorOptions: selectClientReferrers,
  },
  status: {
    type: 'multi-lookup',
    field: 'status_id',
    caption: 'Status',
    placeholder: 'All',
    selectorOptions: selectAppointmentStatuses,
  },
  client_package: {
    type: 'multi-lookup',
    field: 'package_fixed_id',
    caption: 'Package',
    placeholder: 'All',
    selectorOptions: selectClientPackages,
  },
  service_type: {
    type: 'multi-lookup',
    field: 'service_type_id',
    caption: 'Service Type',
    placeholder: 'All',
    selectorOptions: selectLookupAppointmentServiceTypes,
  },
};

export default fields;
